import { cn } from '@/utils/style';

const SOURCE_LIST = [
  {
    name: '커넥트디아이',
    url: 'https://www.connectdi.com',
  },
  {
    name: '식품의약품안전처',
    url: 'https://uvoice.mfds.go.kr',
  },
];

interface Props {
  onClickSource: (url: string) => () => void;
}

const MedicineGuideSource = (props: Props) => {
  return (
    <section className={'flex flex-col gap-[20px] px-[24px] py-[28px]'}>
      <h2 className={'typography-ui-19sb text-gray-700'}>정보 출처</h2>
      <ul className='flex flex-col gap-[12px]'>
        {SOURCE_LIST.map((item) => {
          return (
            <li
              className={cn([
                'typography-ui-15r text-gray-700',
                'relative pl-[20px]',
                'before:absolute before:top-[10px] before:left-[6px] before:h-[4px] before:w-[4px] before:rounded-full before:bg-gray-700 before:content-[""]',
                'flex gap-[8px]',
              ])}
              key={`source-${item.name}`}
            >
              <span className='typography-ui-15m text-gray-500'>{item.name}</span>
              <span
                className='cursor-pointer text-gray-300 underline decoration-gray-300 underline-offset-auto'
                onClick={props.onClickSource(item.url)}
              >
                {item.url}
              </span>
            </li>
          );
        })}
      </ul>
      <span className='typography-ui-13r text-gray-400'>
        본 콘텐츠의 저작권은 저자 또는 제공처에 있으며, 이를 무단 이용하는 경우 저작권법 등에 따라 법적책임을 질수
        있습니다.
        <br />
        외부저작권자가 제공한 콘텐츠는 닥터나우의 입장과 다를 수 있습니다.
      </span>
    </section>
  );
};

export default MedicineGuideSource;
